import React, { Component } from "react";
import { fmtInt } from "../common/formatters";
import Axios from "axios";
import { getUser } from "../../actions/session";
import { LOGIN_URL, SERVER_PATH } from "../../config/rest_endpoints";
import CustomLoader from "../common/loader";
import { Notifications } from "../common/notification";
import { Redirect } from "react-router";
import Container from "../common/application_container";
import MultiSelect from "@khanacademy/react-multi-select";
import { ALL_ACCOUNT_LIST } from "../../config/rest_endpoints";

// datetime picker imports
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";

class AccountRejectionReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      User: getUser(),
      data: [],
      startDate: moment(),
      endDate: moment(),
      isGetting: false,
      isLoginURL: false,
      isBtnSpin: false,
      accountList: [],
      selectedAccount: [],
      excludeNoActivity: true,
      expandedRows: {},
      expandedSubRows: {},
      subSortOrder: {},
    };
    this.getReportOnSelectDate = this.getReportOnSelectDate.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.getAllAccountNames = this.getAllAccountNames.bind(this);
    this.handleExcludeNoActivity = this.handleExcludeNoActivity.bind(this);
    this.toggleRow = this.toggleRow.bind(this);
    this.toggleSubRow = this.toggleSubRow.bind(this);
    this.sortSubTableByCount = this.sortSubTableByCount.bind(this);
  }

  componentDidMount() {
    this.getReportOnSelectDate();
  }

  // handle date and time on selection of datetime picker
  handleDate(date, value) {
    if (value == "start") {
      this.setState({ startDate: date });
    } else {
      this.setState({ endDate: date });
    }
  }

  getAllAccountNames() {
    const { User } = this.state;
    var headers = { Authorization: "Bearer " + User.token };
    Axios.get(ALL_ACCOUNT_LIST, { headers })
      .then((res) => {
        if (res) {
          var resp = res.data.data;
          const list = resp.map((row) => {
            row["label"] = row["accountName"];
            row["value"] = row["id"];
            return row;
          });
          this.setState({ accountList: list });
        }
      })
      .catch((err) => {
        console.log("Error fetching accounts:", err);
      });
  }

  handleExcludeNoActivity(e) {
    this.setState({ excludeNoActivity: e.target.checked });
  }

  toggleRow(rowId) {
    const { expandedRows } = this.state;
    this.setState({
      expandedRows: {
        ...expandedRows,
        [rowId]: !expandedRows[rowId]
      }
    });
  }

  toggleSubRow(parentId, subRowId) {
    const { expandedSubRows } = this.state;
    const key = `${parentId}-${subRowId}`;
    this.setState({
      expandedSubRows: {
        ...expandedSubRows,
        [key]: !expandedSubRows[key]
      }
    });
  }

  sortSubTableByCount(accountIdx) {
    const { data, subSortOrder } = this.state;
    const currentOrder = subSortOrder[accountIdx] || 'desc';
    const newOrder = currentOrder === 'asc' ? 'desc' : 'asc';
    
    const updatedData = [...data];
    if (updatedData[accountIdx] && updatedData[accountIdx].stats) {
      const stats = [...updatedData[accountIdx].stats];
      
      stats.sort((a, b) => {
        const aCount = a.count || 0;
        const bCount = b.count || 0;
        return newOrder === 'asc' ? aCount - bCount : bCount - aCount;
      });
      
      updatedData[accountIdx].stats = stats;
      
      this.setState({
        data: updatedData,
        subSortOrder: {
          ...subSortOrder,
          [accountIdx]: newOrder
        }
      });
    }
  }

  // get rejection report on selected date
  getReportOnSelectDate() {
    const { User, startDate, endDate } = this.state;
    var payload = {
      startDate: moment(startDate).format("MM/DD/YYYY, h:mm:ss A"),
      endDate: moment(endDate).format("MM/DD/YYYY, h:mm:ss A"),
      accounts: [],
      excludeOnesWithNoActivity: true,
    };
    
    this.setState({ isGetting: true, isBtnSpin: true });
    var headers = { Authorization: "Bearer " + User.token };
    
    const url = `${SERVER_PATH}/apiv1/reporting/account/stats/rejection`;
    Axios.post(url, payload, { headers })
      .then((res) => {
        console.log('API Response:', res);
        console.log('Response Data:', res.data);
        if (res && res.data && res.data.data) {
          var resp = res.data.data;
          console.log('Extracted Data:', resp);
          console.log('Extracted Data Type:', typeof resp);
          console.log('Is Array Check:', Array.isArray(resp));
          
          // Direct assignment without array check since API returns array
          this.setState({
            data: resp.data,
            isGetting: false,
            isBtnSpin: false,
          }, () => {
            console.log('State after update:', this.state.data);
            console.log('State data length:', this.state.data.length);
          });
        } else {
          console.log('No data found in response');
          this.setState({
            data: [],
            isGetting: false,
            isBtnSpin: false,
          });
        }
      })
      .catch((err) => {
        console.log('API Error:', err);
        const alert = err.response;
        if (alert && alert.data && alert.data.message === "invalid or expired jwt") {
          localStorage.removeItem("user");
          this.setState({ isLoginURL: true });
          Notifications.notify(alert.data.message, "Token Expire", "error");
        } else {
          const errorMsg = alert && alert.data && alert.data.message ? alert.data.message : "Error occurred";
          Notifications.notify(errorMsg, "Failed", "error");
        }
        this.setState({
          data: [],
          isGetting: false,
          isBtnSpin: false,
        });
      });
  }

  renderReportTable() {
    const { data, expandedRows, expandedSubRows } = this.state;
    
    if (!data || !Array.isArray(data) || data.length === 0) {
      return (
        <tr>
          <td colSpan="4" className="text-center">
            No rejection data found
          </td>
        </tr>
      );
    }

    return data.map((account, idx) => {
      const isExpanded = expandedRows[idx] || false;
      const accountName = account.accountName || 'Unknown Account';
      const accountId = account.account_id || account.accountId || 'N/A';
      const stats = account.stats || [];
      
      return (
        <React.Fragment key={idx}>
          {/* Main Account Row */}
          <tr className="left_align">
            <td style={{ width: "50px", textAlign: "center" }}>
              <i
                className={`icon-plus3 ${
                  isExpanded ? "icon-minus3" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => this.toggleRow(idx)}
              ></i>
            </td>
            <td>{accountName}</td>
            <td style={{ textAlign: "right" }}>{fmtInt(stats.reduce((total, stat) => total + (stat.count || 0), 0))}</td>
            <td style={{ textAlign: "center" }}>{stats.length} rejection types</td>
          </tr>
          
          {/* Expanded Stats Table */}
          {isExpanded && stats.length > 0 && (
            <tr className="left_align">
              <td colSpan="4" style={{ padding: "0" }}>
                <table className="table table-sm mb-0" style={{ backgroundColor: "#f8f9fa" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#e9ecef" }}>
                      <th style={{ paddingLeft: "50px" }}>Rejection Reason</th>
                      <th style={{ textAlign: "right", cursor: "pointer" }} onClick={() => this.sortSubTableByCount(idx)}>
                        Count
                        <i className={`ml-1 ${(this.state.subSortOrder[idx] || 'desc') === 'asc' ? 'icon-sort-amount-asc' : 'icon-sort-amount-desc'}`}></i>
                      </th>
                      <th style={{ textAlign: "right" }}>Percentage</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stats.map((stat, statIdx) => {
                      const reason = stat.reason || 'Unknown Reason';
                      const count = stat.count || 0;
                      const totalCount = stats.reduce((total, s) => total + (s.count || 0), 0);
                      const percentage = totalCount > 0 ? ((count / totalCount) * 100).toFixed(2) : 0;
                      return (
                        <tr key={`${idx}-${statIdx}`}>
                          <td style={{ paddingLeft: "50px" }}>{reason}</td>
                          <td style={{ textAlign: "right" }}>{fmtInt(count)}</td>
                          <td style={{ textAlign: "right" }}>{percentage}%</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </td>
            </tr>
          )}
          
          {/* Show message if no stats */}
          {isExpanded && stats.length === 0 && (
            <tr className="left_align" style={{ backgroundColor: "#f8f9fa" }}>
              <td colSpan="4" className="text-center text-muted" style={{ padding: "20px" }}>
                No rejection stats available for this account
              </td>
            </tr>
          )}
        </React.Fragment>
      );
    });
  }

  render() {
    const { startDate, endDate, isGetting, isBtnSpin } = this.state;
    
    if (this.state.isLoginURL === true) {
      return <Redirect to={LOGIN_URL}></Redirect>;
    }

    return (
      <Container title="Account" title1="Rejection" icon="fa fa-ban">
        <div className="card border-left-dark-alpha border-right-dark-alpha">
          <div className="card-body">
            {/* Date Range Selection */}
            <div className="d-flex justify-content-between flex-wrap bg-light rounded border p-0 mb-2">
              <div className="py-2 px-3 mb-1">
                <label style={{ fontWeight: "400", fontSize: "16px" }}>
                  Start Date
                  <span className="fs-11 text-muted"> UTC Time-zone</span>
                </label>
                <div className="input-group">
                  <DateRangePicker
                    showWeekNumbers
                    onCallback={(date) => this.handleDate(date, "start")}
                    initialSettings={{
                      singleDatePicker: true,
                      showDropdowns: true,
                      startDate: moment(startDate),
                      locale: {
                        format: "MMMM/DD/YYYY",
                      },
                    }}
                  >
                    <input
                      type="text"
                      className="form-control"
                      style={{ minWidth: "300px" }}
                    />
                  </DateRangePicker>
                </div>
              </div>
              
              <div className="py-2 px-3 mb-1">
                <label style={{ fontWeight: "400", fontSize: "16px" }}>
                  End Date
                  <span className="text-muted"> UTC Time-zone</span>
                </label>
                <div className="input-group">
                  <DateRangePicker
                    onCallback={(date) => this.handleDate(date, "end")}
                    initialSettings={{
                      singleDatePicker: true,
                      showDropdowns: true,
                      startDate: moment(endDate),
                      locale: {
                        format: "MMMM/DD/YYYY",
                      },
                    }}
                  >
                    <input
                      type="text"
                      className="form-control"
                      style={{ minWidth: "300px" }}
                    />
                  </DateRangePicker>
                </div>
              </div>
              
              <div className="py-2 px-3 mb-1">
                <div
                  className="d-flex flex-column align-items-start"
                  style={{ marginTop: "2.5em" }}
                >
                  <button
                    style={{ fontWeight: "600" }}
                    type="submit"
                    className="btn main-button btn-success btn-sm border"
                    onClick={this.getReportOnSelectDate}
                  >
                    Search{" "}
                    <i
                      className={`${
                        isBtnSpin ? "icon-spinner4 spinner" : "icon-arrow-right8"
                      } ml-2`}
                    ></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Results Table */}
            <div className="table-responsive">
              <table className="table table-striped dataTable no-footer">
                <thead>
                  <tr className="table-heading-style">
                    <th style={{ width: "50px", textAlign: "center" }}></th>
                    <th style={{ textAlign: "left" }}>Account Name</th>
                    <th style={{ textAlign: "right" }}>Total Rejections</th>
                    <th style={{ textAlign: "center" }}>Rejection Types</th>
                  </tr>
                </thead>
                <tbody>
                  {isGetting ? (
                    <tr>
                      <td colSpan="4" className="text-center">
                        <CustomLoader />
                      </td>
                    </tr>
                  ) : (
                    this.renderReportTable()
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

export default AccountRejectionReport;